import {Channel, ChatTypingMessage, Event, EventBusInstance, EventBus, LegState, ContactLeg} from "@sap/cpaas-commlib-lib";
import {Component} from "inferno";
import {AppState, Configuration} from "../../../services/configuration";
import {IChatMessage} from "../../../utils/types";
import {Message} from "./message/Message";
import {TypingIndicator} from "./TypingIndicator";
import {isScrolledIntoView} from "../../../utils/util";

export class Transcript extends Component<{ messages: IChatMessage[] }, any> {

	state: { isTyping: boolean } = {
		isTyping: false,
	};
	private endIndicator: HTMLElement;
	private mounted = false;

	componentWillMount() {
		EventBusInstance.subscribe(Event.Chat(Channel.all).typing, this.onTypingChange, this);
		EventBus.subscribe(Configuration.allMessagesRecoveredEvent, this.onAllMessagesReceivedForResumedChat, this, Configuration.component);
		EventBusInstance.subscribe(Event.ContactLeg(Channel.all).change, this.onChatStateChange, this);
	}

	componentWillUnmount() {
		EventBusInstance.unsubscribe(Event.Chat(Channel.all).typing, this.onTypingChange, this);
		EventBus.unsubscribe(Configuration.allMessagesRecoveredEvent, this.onAllMessagesReceivedForResumedChat, this, Configuration.component);
		EventBusInstance.unsubscribe(Event.ContactLeg(Channel.all).change, this.onChatStateChange, this);
	}

	componentWillUpdate() {
		// New chat message -> props update -> componentWillUpdate -> auto-scroll to bottom unless user has scrolled upwards to view previous messages.
		if (isScrolledIntoView(this.endIndicator)) {
			setTimeout(() => {
				this.scrollToView();
			});
		}
	}

	componentDidMount() {
		// View mounted (fully new chat, or UI transitioned from minimized -> maximized) -> auto-scroll to bottom always.
		setTimeout(() => {
			this.scrollToView();
		});
	}

	private async onAllMessagesReceivedForResumedChat() {
		this.scrollToView();
	}

	scrollToView = (element?: HTMLElement) => {
		element = element instanceof HTMLElement ? element : this.endIndicator;
		if (element) {
			if (!this.mounted) {
				setTimeout(() => {
					element.scrollIntoView({behavior: "instant"} as any);
					this.mounted = true;
				}, 200);
			} else {
				element.scrollIntoView({behavior: "smooth"});
			}
		}
	};

	private onTypingChange(channel: string, event: string, message: ChatTypingMessage) {
		if (AppState.activeLeg && AppState.activeLeg.getId() !== message.sender) {
			this.setState({isTyping: message.typing});
		}
	}

	private onChatStateChange(channel: string, event: string, contactLeg: ContactLeg) {
		const state = contactLeg.getState();
		switch (state) {
			case LegState.completed:
			case LegState.done:
				this.setState({isTyping: false});
				break;
			default:
				break;
		}
	}

	render() {
		return (
			<div style={{"overflow-y": "auto", "overflow-x": "hidden"}} className="flex-grow-1 flex-shrink-1 p-2 transcript">
				{this.props.messages.map((message: IChatMessage) => (
					<div key={message.guid} className="message-appear">
						<Message message={message} />
					</div>))}
				{this.state.isTyping && <TypingIndicator/>}
				<div ref={(node: HTMLElement) => this.endIndicator = node}/>
			</div>
		);
	}
}
